export default __webpack_public_path__ + "static/media/IBA.bb4e46d6.png";